function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg",
  strokeWidth: "2"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.91 11.31l-.058-3.409S4.325 2.878 6.47 2.868c2.145-.01 2.608-.17 2.752 4.39s-.567-6.21 1.867-6.162c2.434.048 2.645 1.969 2.42 5.996-.226 4.027-1.457-5.184 1.994-4.605 3.45.58 2.127 2.805 2.123 4.68-.004 1.875-.274-2.902 2.141-2.668 2.416.233 2.13 3.805 2.13 3.805l-.013 8.016s-.333 4.188-5.945 5.909c-5.61 1.72-5.646.371-7.033-.736-1.386-1.108-5.916-5.721-5.916-5.721S-.495 12.14 4.835 8.103",
  fill: "none"
})));